import * as React from 'react'
import { useEffect, useState } from 'react'
import SimpleBarReact from 'simplebar-react'

const SmartScroll = ({
  peerElementClassName,
  dependency,
  containerRef,
  className,
  maxHeight,
  enableHorizontalScroll = false,
  'data-testid': dataTestId,
  id,
  children,
}) => {
  const [peerHeight, setPeerHeight] = useState(0)

  useEffect(() => {
    if (!peerElementClassName) {
      return undefined
    }

    const calculateHeight = () => {
      if (containerRef && containerRef?.current) {
        // Get the height of the elements above the scrollable area
        const peerElementHeight =
          containerRef.current.querySelector(peerElementClassName)?.clientHeight || 0

        setPeerHeight(peerElementHeight)
      }
    }

    // Calculate initially and on window resize
    calculateHeight()
    window.addEventListener('resize', calculateHeight)

    return () => window.removeEventListener('resize', calculateHeight)
  }, [containerRef, dependency, peerElementClassName])

  return (
    <React.Fragment>
      {window.innerWidth < 1024 ? (
        <div className={className} data-testid={dataTestId || 'smart-scroll-mobile-view'}>
          {children}
        </div>
      ) : (
        <div
          className={className}
          style={peerElementClassName ? { height: `calc(100% - ${peerHeight}px)` } : undefined}
          data-testid={dataTestId || 'smart-scroll-container'}
        >
          <SimpleBarReact
            id={id || ''}
            style={{ outline: 0 }}
            className={`h-[100%] ${maxHeight || ''}`}
            data-testid="smart-scroll-bar"
          >
            <div
              data-testid="smart-scroll-content"
              className={enableHorizontalScroll ? 'min-width-content' : ''}
            >
              {children}
            </div>
          </SimpleBarReact>
        </div>
      )}
    </React.Fragment>
  )
}

export default SmartScroll
